<template>
  <transition name="fade">
    <div v-show="show" class="right-modal--back" @click.self="closePopup">
      <div class="right-modal">
        <div class="right-modal-container">
          <div
            v-on:click="closePopup"
            class="right-modal--close cursor-pointer"
          >
            <f-awesome icon="times"></f-awesome>
          </div>
          <div class="right-modal--content">
            <slot name="body"></slot>
          </div>
          <div class="bottom-close text-right mrg-t-30 mrg-b-10">
            <div @click="closePopup" class="btn btn-sm btn-outline-danger">
              <f-awesome icon="times"></f-awesome>
              Закрыть
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "RightModal",
  props: {
    show: Boolean
  },
  watch: {
    show: function(val) {
      if (val === true) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    }
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit("closeRightModal");
    }
  }
};
</script>

<style scoped lang="less">
.right-modal--back {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 19999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow: auto;
}

/* Анимации появления и исчезновения могут иметь */
/* различные продолжительности и динамику.       */
.fade-enter-active {
  transition: all .3s ease;
}
.fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.right-modal {
  width: 400px;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto 0;
  background-color: #fff;
  box-shadow: -2px -1px 28px 0px rgba(0, 0, 0, 0.75);
  box-sizing: border-box;
  z-index: 2;

  .right-modal-container{
    padding-top: 10px;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    overflow: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
}
.right-modal--content {
  margin-top: 15px;
}
.right-modal--close {

  svg {
    font-size: 24px;
  }
}
.bottom-close{
  display: none;
}
@media (max-width: 830px) {
  .right-modal {
    width: 100%;
  }
}

@media (max-width: 450px) {
  .right-modal--close {
    text-align: right;
  }
  .bottom-close{
    display: block;
  }
}
</style>
